import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LearningInformation = styled(Box)`
  text-align: center;
  padding: 48px 24px;
  background: #f5f5f5;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 64px 24px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding: 64px 248px;
  }
`;

export const PatternList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
